module.exports = __webpack_public_path__ + "static/media/brightness.a45101e0.svg";